export const FaxSchema = {
  "@context": "https://schema.org",
  "@graph": [
    {
      "@type": "Organization",
      "@id": "https://navatel.ir/#organization",
      "name": "نواتل",
      "legalName": "نواتل",
      "url": "https://navatel.ir/",
      "logo": {
        "@type": "ImageObject",
        "url": "https://navatel.ir/wp-content/uploads/logo.png"
      },
      "description": "تنها سرویس ارتباطات یکپارچه ابری با اپلیکیشن اختصاصی و بدون محدودیت در ایران؛ ارائه‌دهنده مرکز تلفن ابری، مرکز تماس ابری، خط تلفن اینترنتی، پنل پیامکی و فکس آنلاین.",
      "sameAs": [
        "https://www.linkedin.com/company/mynavatel",
        "https://www.instagram.com/navatel.ir",
        "https://www.threads.com/@navatel.ir"
      ],
      "contactPoint": {
        "@type": "ContactPoint",
        "contactType": "customer service",
        "telephone": "+98-21-82800000",
        "areaServed": "IR",
        "availableLanguage": ["fa"]
      }
    },
    {
      "@type": "WebSite",
      "@id": "https://navatel.ir/#website",
      "url": "https://navatel.ir/",
      "name": "نواتل",
      "publisher": {
        "@id": "https://navatel.ir/#organization"
      },
      "inLanguage": "fa-IR"
    },
    {
      "@type": "WebPage",
      "@id": "https://navatel.ir/products/fax/#webpage",
      "url": "https://navatel.ir/products/fax/",
      "name": "فکس آنلاین نواتل | ارسال و دریافت اسناد بدون دستگاه فکس",
      "description": "با فکس آنلاین نواتل، اسناد را بدون دستگاه فکس فیزیکی و کاغذ، از طریق اینترنت ارسال و دریافت کنید. قابل استفاده با یا بدون مرکز تلفن ابری نواتل.",
      "isPartOf": {
        "@id": "https://navatel.ir/#website"
      },
      "about": {
        "@id": "https://navatel.ir/products/fax/#service"
      },
      "inLanguage": "fa-IR",
      "breadcrumb": {
        "@id": "https://navatel.ir/products/fax/#breadcrumb"
      }
    },
    {
      "@type": "BreadcrumbList",
      "@id": "https://navatel.ir/products/fax/#breadcrumb",
      "itemListElement": [
        {
          "@type": "ListItem",
          "position": 1,
          "name": "خانه",
          "item": "https://navatel.ir/"
        },
        {
          "@type": "ListItem",
          "position": 2,
          "name": "محصولات",
          "item": "https://navatel.ir/products/"
        },
        {
          "@type": "ListItem",
          "position": 3,
          "name": "فکس آنلاین",
          "item": "https://navatel.ir/products/fax/"
        }
      ]
    },
    {
      "@type": "Service",
      "@id": "https://navatel.ir/products/fax/#service",
      "name": "فکس ابری نواتل",
      "alternateName": "فکس آنلاین / فکس اینترنتی نواتل",
      "serviceType": "فکس ابری (Online / Cloud Fax)",
      "description": "فکس ابری نواتل امکان ارسال و دریافت اسناد را بدون نیاز به دستگاه فکس فیزیکی، کاغذ، جوهر و خط تلفن سنتی فراهم می‌کند. ارسال و دریافت از طریق پروتکل اینترنت (IP) و با استفاده از اپلیکیشن اختصاصی نواتل (اندروید) یا ایمیل انجام می‌شود؛ بدون محدودیت در تعداد فکس ارسالی و دریافتی.",
      "provider": {
        "@id": "https://navatel.ir/#organization"
      },
      "areaServed": {
        "@type": "Country",
        "name": "Iran"
      },
      "audience": {
        "@type": "BusinessAudience",
        "audienceType": "کسب‌وکارها و سازمان‌ها (B2B)"
      },
      "url": "https://navatel.ir/products/fax/",
      "brand": {
        "@id": "https://navatel.ir/#organization"
      },
      "additionalProperty": {
        "@type": "PropertyValue",
        "name": "دوره پرداخت اشتراک",
        "value": "پرداخت سالانه (نمایش قیمت به‌صورت ماهانه)"
      },
      "offers": [
        {
          "@type": "Offer",
          "name": "فکس ابری نواتل - بدون مرکز تلفن ابری نواتل",
          "description": "مناسب سازمان‌هایی که صرفاً به سرویس فکس ابری نیاز دارند. شامل ارسال و دریافت فکس به تعداد نامحدود، آرشیو فکس‌ها، دریافت فکس در ایمیل، دریافت فکس در اپلیکیشن نواتل، ۲ کانال هم‌زمانی رایگان و ۱ گیگابایت فضای ذخیره‌سازی فکس ابری اختصاصی.",
          "url": "https://navatel.ir/products/fax/",
          "priceCurrency": "IRR",
          "price": "3960000",
          "availability": "https://schema.org/InStock",
          "priceSpecification": {
            "@type": "UnitPriceSpecification",
            "priceCurrency": "IRR",
            "price": "3960000",
            "unitText": "ماه",
            "billingDuration": "P1Y"
          }
        },
        {
          "@type": "Offer",
          "name": "فکس ابری نواتل - همراه با مرکز تلفن ابری نواتل",
          "description": "پیشنهاد ویژه؛ مناسب سازمان‌هایی که به دنبال راهکار ارتباطی یکپارچه هستند. شامل ارسال و دریافت فکس به تعداد نامحدود، آرشیو فکس‌ها، دریافت فکس در ایمیل، دریافت فکس در اپلیکیشن نواتل، ۲ کانال هم‌زمانی رایگان و فضای ذخیره‌سازی ابری مشترک با مرکز تلفن.",
          "url": "https://navatel.ir/products/fax/",
          "priceCurrency": "IRR",
          "price": "3480000",
          "availability": "https://schema.org/InStock",
          "priceSpecification": {
            "@type": "UnitPriceSpecification",
            "priceCurrency": "IRR",
            "price": "3480000",
            "unitText": "ماه",
            "billingDuration": "P1Y"
          }
        }
      ]
    }
  ]
}